import React from 'react';
import { Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const AutosaveBadge = ({
  timestamp,
  ...props
}: {
  timestamp: number;
  [key: string]: any;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Text
      fontSize='xs'
      bg='red.50'
      p='1'
      color='gray.500'
      borderRadius='md'
      {...props}
    >
      {t('proposal.autosaveBadge', 'Wersja robocza (autosave) z dnia:')}{' '}
      {new Date(timestamp).toLocaleString()}
    </Text>
  );
};
